import axios from 'axios';
import { PartnerAttrib, setUserStatus } from '../features/authSlice';
import { MAX_FILE_SIZE_MB } from './constants';
import { getCookieValue } from '../App';

export const fieldsToCheck = [
  'orgDisplayName',
  'tag',
  'description',
  'primaryColor',
  'secondaryColor',
  'tertiaryColor',
  'quaternaryColor',
  'logo',
  'logoMobile',
  'banner',
  'logoMonochrome',
  'b2cLink',
  'appDeepLink',
  'icon',
  'logoNewsletter',
  'logoBannerUrl',
];

export const downloadImage = (img: string, fileName: string = '') => {
  const link = document.createElement('a');
  link.href = img;

  if (img.startsWith('data:')) {
    link.download = fileName; // Use provided or default filename
  } else {
    // Extract filename if it's a standard URL
    link.download = img.substring(img.lastIndexOf('/') + 1).split('.')[0];
  }

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadImageHTTPS = async (url: string): Promise<void> => {
  try {
    const response = await axios.get(url, {
      responseType: 'blob',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Cache-Control': 'no-cache',
      },
    });
    const urlBlob = window.URL.createObjectURL(new Blob([response.data]));

    const link = document.createElement('a');
    link.href = urlBlob;
    link.setAttribute('download', 'qr-code.png');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  } catch (error) {
    console.error('Failed to download image:', error);
  }
};

export const getStartAndEndDates = (): {
  startDate: string;
  endDate: string;
} => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  let endDate = today;
  let startDate;
  startDate = new Date(
    tomorrow.getFullYear(),
    tomorrow.getMonth() - 8,
    tomorrow.getDate()
  );

  return {
    startDate: startDate.toISOString().split('T')[0],
    endDate: endDate.toISOString().split('T')[0],
  };
};

export function determineUserStatus(
  partnerAttrib: PartnerAttrib[],
  dispatch: (action: any) => void
) {
  const brandInfoAttrib = partnerAttrib.find(
    (attrib: PartnerAttrib) => attrib.name === 'brandInfo'
  );

  const brandGoLiveAttrib = partnerAttrib.find(
    (attrib: PartnerAttrib) => attrib.name === 'goLive'
  );

  if (brandGoLiveAttrib?.value === 'completed') {
    dispatch(setUserStatus('active'));
  } else if (brandInfoAttrib?.value === 'completed') {
    dispatch(setUserStatus('inreview'));
  } else {
    dispatch(setUserStatus('inactive'));
  }
}

export const handleFileChange = (
  event: React.ChangeEvent<HTMLInputElement>,
  fieldName: any,
  setFileName: (name: string) => void,
  setIsUpdated: (updated: boolean) => void,
  setError: any,
  clearErrors: any,
  onFileReady?: (file: File) => void
) => {
  const file = event.target.files?.[0];

  if (file) {
    const isTooLarge = file.size > MAX_FILE_SIZE_MB * 1024 * 1024;

    if (isTooLarge && fieldName !== 'banner') {
      setError(fieldName, {
        type: 'manual',
        message: 'Upload Error: Max File Size Allowed is 2Mb',
      });
    } else {
      clearErrors(fieldName);
      setFileName(file.name);
      setIsUpdated(true);
      if (onFileReady) {
        onFileReady(file);
      }
    }
  }
};

export const urlToFileList = async (
  url: string,
  mimeType?: string
): Promise<FileList> => {
  const response = await fetch(url);
  const blob = await response.blob();

  // استنتاج الاسم من الرابط
  const urlParts = url.split('/');
  const fileName = urlParts[urlParts.length - 1] || 'file';

  const file = new File([blob], fileName, { type: mimeType || blob.type });

  const dataTransfer = new DataTransfer();
  dataTransfer.items.add(file);
  return dataTransfer.files;
};

export const checkB2CLink = async (
  controller: AbortController,
  linkName: string
) => {
  try {
    const token = getCookieValue('token');
    await axios.post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/pmo/c/b/l`,
      {
        b2cLink: linkName,
      },
      {
        signal: controller.signal,
        headers: {
          'x-api-key': process.env.REACT_APP_ADMIN_X_API_KEY,
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      }
    );
    return true;
  } catch (error: any) {
    if (error?.response?.status === 409) {
      return false;
    }
  }
};
export const checkAliasLink = async (
  controller: AbortController,
  linkName: string
) => {
  try {
    const token = getCookieValue('token');
    await axios.post(
      `${process.env.REACT_APP_ADMIN_BASE_URL}/pmo/c/q/a`,
      {
        deepLinkAlias: linkName,
      },
      {
        signal: controller.signal,
        headers: {
          'x-api-key': process.env.REACT_APP_ADMIN_X_API_KEY,
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      }
    );
    return true;
  } catch (error: any) {
    if (error?.response?.status === 409) {
      return false;
    }
  }
};
